import { useCallback } from 'react'

import { loadHostMeetingPrepRemote } from './loadHostMeetingPrepRemote'

export const useOpenMeetingPrepFromHost = () => (
  useCallback(async (contact, meeting) => {
    try {
      const mod = await loadHostMeetingPrepRemote()
      if (!mod?.openMeetingPrepFromHost) return false

      mod.openMeetingPrepFromHost(contact, meeting)
      return true
    } catch {
      // Remote missing/outdated - intentionally no-op.
      return false
    }
  }, [])
)
